import React from 'react';

// GLOBAL FUNCTIONS
import { checkRole } from 'functions.js';

// LOCAL TOOLS
import AddSaleButton from '../tools/AddSaleButton';
import ConvertSidebar from '../tools/ConvertSidebar';
import EpostButton from '../tools/EPostButton';
import Pagination from '../tools/Pagination';
import PrintButton from '../tools/PrintButton';
import ReturnSidebar from '../tools/ReturnSidebar';
import WholesaleToggle from '../tools/WholesaleToggle';

// STYLE
import styles from './inventoryButtons.module.scss';

// MAIN COMPONENT
const InventoryButtons = () => (<>
  <div className={styles.container}>
    <div className={styles.left}>
      {checkRole(['dslAdmin', 'salesManager', 'salesManagerPlus']) && <AddSaleButton />}
      <PrintButton />
      {checkRole(['dslAdmin', 'inventoryManager', 'salesManager', 'salesManagerPlus']) && <>
        <ReturnSidebar.Button />
        <ConvertSidebar.Button />
        <EpostButton />
        <WholesaleToggle />
      </>}
    </div>
    <div className={styles.right}>
      <Pagination />
    </div>
  </div>
  <ReturnSidebar />
  <ConvertSidebar />
</>);

// EXPORT
export default InventoryButtons;
